<template>
  <div class="row">
    <!-- Label -->
    <div class="col-3">
      {{ label }}
    </div>

    <!-- Slider -->
    <div class="col-6">
      <input
        :id="slug"
        type="range"
        class="form-range"
        :min="min"
        :max="max"
        :step="step"
        :data-cy="slug"
        :name="slug"
        :value="model"
        @input="$emit(`update:${slug}`,$event.target.value)"
      >
    </div>

    <!-- Description -->
    <div class="col-3">
      {{ description }}
    </div>

    <!-- Message d'erreur -->
    <div class="col-12">
      <ErrorMessage :validation-status="v$[slug]" />
    </div>
  </div>
</template>


<script>
import ErrorMessage from "./ErrorMessage"
import {computed} from 'vue'

export default {
  name: "SliderInput",
  components: {
    ErrorMessage
  },
  props: {
    label: {
      type: String,
      required: true
    },
    slug: {
      type: String,
      required: true
    },
    model: {
      type: String,
      required: true
    },
    min: {
      type: String,
      default: () => "0"
    },
    max: {
      type: String,
      default: () => "100"
    },
    step: {
      type: String,
      default: () => "10"
    },
    descriptionMap: {
      type: Object,
      required: true
    },
    v$: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const description = computed(() => {
      return props.descriptionMap[props.model]
    })

    return {
      description
    }
  }
}
</script>

<style scoped>

</style>
